app.factory('visitMockService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function VisitService() {

            this.getDataPage = function(criteria) {
                var d = $q.defer();

                baseService.get('./resource/mock/visitList.json').then(
                    function(successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, VisitVO);
                        dataPage.data = objectHelper.convertTimesToDates(dataPage.data);

                        d.resolve(dataPage);
                    },
                    function(errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getById = function(id) {
                var d = $q.defer();

                baseService.get(config.API_URL + '/visits/' + id).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, VisitVO);
                        data = objectHelper.convertTimesToDates(data);

                        d.resolve(data);
                    },
                    function(errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

        }

        return new VisitService();
    }
]);
